export const global = {
    body: {
        fontFamily: 'body',
        bg: 'background.light'
    },
}